import React from 'react'
// import styles from './styles.css'
import PropTypes from 'prop-types'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import isEmpty from 'lodash/isEmpty'
import NoFields from './NoFields'
import Fields from './Fields'
import Title from './Title'

@withGraphQL(gql`
  query document($documentId: ID) {
    document(documentId: $documentId) {
      _id
      fieldsName
      fieldsValues
      documentOwner
    }
  }
`)
export default class FillNameFields extends React.Component {
  static propTypes = {
    document: PropTypes.object
  }

  state = {}

  render() {
    if (!this.props.document.documentOwner) return null
    if (!this.props.document.fieldsName || isEmpty(this.props.document.fieldsName)) {
      return (
        <div className="section">
          <Title />
          <NoFields document={this.props.document} />
        </div>
      )
    } else {
      return (
        <div className="section">
          <Title />
          <Fields document={this.props.document} />
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/FillNameFields/index.js